import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
import { BanksActionType } from '../actions/actions';
import BanksState from '../state/state';

const Banks = (state = new BanksState({}), action: GeneralAction<BanksActionType>) => {
    switch (action.type) {
        case BanksActionType.GETTING_BANKS: {
            return state.copyWith({ status: StateStatus.loading });
        }
        case BanksActionType.GETTING_BANKS_SUCCESS: {
            return state.copyWith({
                status: StateStatus.success,
                banks: action.payload
            });
        }
        case BanksActionType.GETTING_BANKS_FAILURE: {
            return state.copyWith({
                status: StateStatus.failure,
                banks: [],
                error: action.payload
            });
        }
        default:
            return state;
    }
};

export default Banks;
